import { useState } from "react";
import {
    Container,
    Table,
    NumberInput,
    Slider,
    Text,
    Card,
    Grid,
    TextInput, Select,
} from "@mantine/core";
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    Tooltip,
    ResponsiveContainer,
    CartesianGrid,
    Cell
} from "recharts";

const defaultVehicles = [
    "Scooters",
    "Cars",
    "Buses",
    "Trucks",
    "3Wheelers",
    "Vehicle 1",
    "Vehicle 2",
    "Vehicle 3",
    "Vehicle 4",
    "Vehicle 5",
];

// 🔥 CO2 factors
const fuelFactors = {
    Petrol: 2.3,
    Diesel: 2.6,
    Gas: 2.7,
    Electric: 0,
};

// bar charts colors
const COLORS = [
    "#4dabf7",
    "#51cf66",
    "#ffd43b",
    "#ff6b6b",
    "#845ef7",
    "#20c997",
    "#66d9e8",
    "#f783ac",
    "#fcc419",
    "#ff922b",
];


const Home = () => {

    const [vehicles, setVehicles] = useState(
        defaultVehicles.map((name) => ({
            name,
            fuel: "Petrol",
            hours: 2,
            speed: 30,
            days: 300,
            efficiency: 20,
            count: 1000,
        }))
    );

    // const [result, setResult] = useState({
    //     totalFuel: 0,
    //     totalCO2: 0,
    // });

    const updateVehicle = (index, key, value) => {
        const updated = [...vehicles];
        updated[index][key] =
            value === "" || value === null ? 0 : value;
        setVehicles(updated);
    };

    const updateName = (index, value) => {
        const updated = [...vehicles];
        updated[index].name = value;
        setVehicles(updated);
    };
    const getShortLabel = (name, fuel) => {
        const cleanName = name.trim();

        const firstTwo =
            cleanName.length >= 2
                ? cleanName.slice(0, 2).toUpperCase()
                : cleanName.toUpperCase();

        const fuelLetter = fuel ? fuel[0].toUpperCase() : "";

        return `${firstTwo}-${fuelLetter}`;
    };
    const chartData = vehicles.map((v) => {
        const vktDay = v.hours * v.speed;
        const vktYear = vktDay * v.days;

        const fuel = vktYear / (v.efficiency || 1);
        const cityFuel = fuel * v.count;

        const emissionFactor = fuelFactors[v.fuel] || 0;
        const co2 = (cityFuel * emissionFactor) / 1e9;

        return {
            name: getShortLabel(v.name, v.fuel), // 🔥 THIS IS KEY
            fullName: v.name,                   // for tooltip
            fuel: v.fuel,
            vkt: Math.round(vktYear),
            // co2: Number(co2.toFixed(2)),
            co2: co2
        };
    });
    // const chartData = vehicles.map((v) => {
    //     const vktDay = v.hours * v.speed;
    //     const vktYear = vktDay * v.days;

    //     const fuel = vktYear / (v.efficiency || 1);
    //     const cityFuel = fuel * v.count;

    //     const emissionFactor = fuelFactors[v.fuel] || 0;
    //     const co2 = (cityFuel * emissionFactor) / 1e9;

    //     return {
    //         name: v.name,
    //         vkt: Math.round(vktYear),
    //         co2: Number(co2.toFixed(2)),
    //     };
    // });

    // useEffect(() => {
    //     let totalFuel = 0;
    //     let totalCO2 = 0;

    //     vehicles.forEach((v) => {
    //         const vktDay = v.hours * v.speed;
    //         const vktYear = vktDay * v.days;
    //         const fuel = vktYear / (v.efficiency || 1);
    //         const cityFuel = fuel * v.count;

    //         const emissionFactor = fuelFactors[v.fuel] || 0;

    //         totalFuel += cityFuel;
    //         totalCO2 += (cityFuel * emissionFactor) / 1e9;
    //     });

    //     setResult({ totalFuel, totalCO2 });
    // }, [vehicles]);

    // const [vehicles, setVehicles] = useState(
    //     defaultVehicles.map((name) => ({
    //         name,
    //         hours: 2,
    //         speed: 30,
    //         days: 300,
    //         efficiency: 20,
    //         count: 1000,
    //         fuelCost: 95,
    //     }))
    // );

    // const [result, setResult] = useState({
    //     totalFuel: 0,
    //     totalCO2: 0,
    // });

    // const updateVehicle = (index, key, value) => {
    //     const updated = [...vehicles];
    //     updated[index][key] =
    //         value === "" || value === null ? 0 : Number(value);
    //     setVehicles(updated);
    // };

    // const updateName = (index, value) => {
    //     const updated = [...vehicles];
    //     updated[index].name = value;
    //     setVehicles(updated);
    // };

    // useEffect(() => {
    //     let totalFuel = 0;
    //     let totalCO2 = 0;

    //     vehicles.forEach((v) => {
    //         const vktDay = v.hours * v.speed;
    //         const vktYear = vktDay * v.days;
    //         const fuel = vktYear / (v.efficiency || 1);
    //         const cityFuel = fuel * v.count;

    //         totalFuel += cityFuel;

    //         // CO2 (kg → million tons)
    //         totalCO2 += (cityFuel * 2.5) / 1e9;
    //     });

    //     setResult({ totalFuel, totalCO2 });
    // }, [vehicles]);

    return (
        <Container size="xl" py="md">
            <Text size="xl" fw={700} ta="center" mb="md">
                -- VAPIS Calculators -- Estimating VKT from Vehicle Speeds --
            </Text>

            <Card shadow="md" p="md" radius="lg" withBorder>
                <Text size="sm" c="dimmed" mb="xs">
                    Green cells are inputs; vehicle names & fuel type can be edited; all are average numbers; use sliders to simulate; scroll down for notes on the calculator

                </Text>
                <div style={{ overflowX: "auto" }}>
                    <Table
                        striped
                        withColumnBorders
                        highlightOnHover
                        fontSize="md"
                        styles={{
                            th: { textAlign: "center" },
                            td: { textAlign: "center" },
                        }}
                    >
                        <thead>
                            <tr>
                                <th style={{ width: 80, fontSize: "16px" }}>Vehicle</th>
                                <th style={{ width: 80, fontSize: "16px" }}>Fuel Type</th>
                                <th style={{ width: 80, fontSize: "16px" }}>On-road hours/day</th>
                                <th style={{ width: 80, fontSize: "16px" }}>Speed (kmph)</th>
                                <th style={{ width: 80, fontSize: "16px" }}>Operating days/year</th>
                                <th style={{ width: 80, fontSize: "16px" }}>VKT/year</th>
                                <th style={{ width: 80, fontSize: "16px" }}># Of in-use vehicles</th>
                                <th style={{ width: 80, fontSize: "16px" }}>Mileage (km/lit or km/kg) </th>
                                <th style={{ width: 80, fontSize: "16px" }}>CO2 (million-tons/year)</th>
                            </tr>
                        </thead>

                        <tbody>
                            {vehicles.map((v, i) => {
                                // const vktDay = v.hours * v.speed;
                                // const vktYear = vktDay * v.days;
                                // const fuel = vktYear / (v.efficiency || 1);
                                // const cityFuel = fuel * v.count;
                                // const co2 = (cityFuel * 2.5) / 1e9;
                                const vktDay = v.hours * v.speed;
                                const vktYear = vktDay * v.days;
                                const fuel = vktYear / (v.efficiency || 1);
                                const cityFuel = fuel * v.count;

                                const emissionFactor = fuelFactors[v.fuel] || 0;
                                const co2 = (cityFuel * emissionFactor) / 1e9;

                                return (
                                    <tr key={i}>
                                        {/* NAME */}
                                        <td style={{ verticalAlign: "top" }} >
                                            <TextInput
                                                value={v.name}
                                                onChange={(e) =>
                                                    updateName(i, e.target.value)
                                                }
                                                styles={{
                                                    input: {
                                                        textAlign: "center",
                                                        fontSize: "16px",
                                                        background: "transparent",
                                                        // border: "none",
                                                    },
                                                }}
                                            />
                                        </td>
                                        {/* FUEL Type*/}
                                        <td style={{ verticalAlign: "top" }}>
                                            <Select
                                                value={v.fuel}
                                                data={[
                                                    "Petrol",
                                                    "Diesel",
                                                    "Gas",
                                                    "Electric",
                                                ]}
                                                onChange={(val) =>
                                                    updateVehicle(i, "fuel", val)
                                                }
                                                styles={{
                                                    input: {
                                                        textAlign: "center",
                                                        fontSize: "16px",
                                                        background: "transparent",
                                                        // border: "none",
                                                    },
                                                }}

                                            />
                                        </td>

                                        {/* HOURS */}
                                        <td style={{ background: "#e6f4ea", verticalAlign: "top" }}>
                                            <NumberInput
                                                value={v.hours}
                                                step={0.1}
                                                min={0}
                                                max={24}
                                                onChange={(val) =>
                                                    updateVehicle(i, "hours", val)
                                                }
                                                hideControls
                                                styles={{
                                                    input: {
                                                        textAlign: "center",
                                                        fontSize: "16px",
                                                        background: "transparent",
                                                        // border: "none",
                                                    },
                                                }}
                                            />
                                            <Slider
                                                value={v.hours}
                                                min={0}
                                                max={24}
                                                step={0.1}
                                                onChange={(val) =>
                                                    updateVehicle(i, "hours", val)
                                                }
                                                size={'xs'}
                                                style={{ flex: 1 }}
                                            //m={'sm'}
                                            />
                                        </td>

                                        {/* SPEED */}
                                        <td style={{ background: "#e6f4ea", verticalAlign: "top" }}>
                                            <NumberInput
                                                value={v.speed}
                                                min={10}
                                                max={80}
                                                onChange={(val) =>
                                                    updateVehicle(i, "speed", val)
                                                }
                                                hideControls
                                                styles={{
                                                    input: {
                                                        textAlign: "center",
                                                        fontSize: "16px",
                                                        background: "transparent",
                                                        // border: "none",
                                                    },
                                                }}
                                            />
                                            <Slider
                                                value={v.speed}
                                                min={10}
                                                max={80}
                                                step={1}
                                                onChange={(val) =>
                                                    updateVehicle(i, "speed", val)
                                                }
                                                size={'xs'}
                                                style={{ flex: 1 }}
                                            />
                                        </td>

                                        {/* DAYS */}
                                        <td style={{ background: "#e6f4ea", verticalAlign: "top" }}>
                                            <NumberInput
                                                value={v.days}
                                                min={100}
                                                max={365}
                                                onChange={(val) =>
                                                    updateVehicle(i, "days", val)
                                                }
                                                hideControls
                                                styles={{
                                                    input: {
                                                        textAlign: "center",
                                                        fontSize: "16px",
                                                        background: "transparent",
                                                        // border: "none",
                                                    },
                                                }}
                                            />
                                            <Slider
                                                value={v.days}
                                                min={100}
                                                max={365}
                                                step={1}
                                                onChange={(val) =>
                                                    updateVehicle(i, "days", val)
                                                }
                                                size={'xs'}
                                                style={{ flex: 1 }}
                                            />
                                        </td>
                                        {/* Output Vkt/year */}
                                        <td style={{ fontWeight: 500, textAlign: 'center', verticalAlign: "top" }}>{vktYear.toLocaleString()}</td>

                                        {/* VEHICLE COUNT */}
                                        <td style={{ background: "#e6f4ea", verticalAlign: "top" }}>
                                            <NumberInput
                                                value={v.count}
                                                min={0}
                                                onChange={(val) =>
                                                    updateVehicle(i, "count", val)
                                                }
                                                hideControls
                                                styles={{
                                                    input: {
                                                        textAlign: "center",
                                                        fontSize: "16px",
                                                        background: "transparent",
                                                        // border: "none",
                                                    },
                                                }}
                                            />
                                        </td>

                                        {/* EFFICIENCY */}
                                        <td style={{ background: "#e6f4ea", verticalAlign: "top" }}>
                                            <NumberInput
                                                value={v.efficiency}
                                                min={1}
                                                onChange={(val) =>
                                                    updateVehicle(i, "efficiency", val)
                                                }
                                                hideControls
                                                styles={{
                                                    input: {
                                                        textAlign: "center",
                                                        fontSize: "16px",
                                                        background: "transparent",
                                                        // border: "none",
                                                    },
                                                }}
                                            />
                                            <Slider
                                                value={v.efficiency}
                                                min={1}
                                                max={50}
                                                step={1}
                                                onChange={(val) =>
                                                    updateVehicle(i, "efficiency", val)
                                                }
                                                size={'xs'}
                                                style={{ flex: 1 }}
                                            />
                                        </td>



                                        {/* OUTPUT */}

                                        <td style={{ fontWeight: 500, textAlign: 'center', verticalAlign: "top" }}>{co2.toFixed(3)}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </Table>
                </div>
            </Card>

            {/* RESULTS */}
            {/* <Card mt="md" p="lg" radius="lg" withBorder>
                <Grid>
                    <Grid.Col span={6}>
                        <Text>Total Fuel Consumption</Text>
                        <Text fw={700} size="xl" c="teal">
                            {(result.totalFuel / 1e6).toFixed(1)} mil litres
                        </Text>
                    </Grid.Col>

                    <Grid.Col span={6}>
                        <Text>Total CO2 Emissions</Text>
                        <Text fw={700} size="xl" c="red">
                            {result.totalCO2.toFixed(2)} mil tons
                        </Text>
                    </Grid.Col>
                </Grid>
            </Card> */}
            {/* Visualization */}
            <Card mt="md" p="xl" radius="xl" withBorder shadow="lg">
                <Text fw={700} size="lg" mb="xl" ta="center">
                    Visualization
                </Text>

                <Grid>
                    {/* 🔵 VKT CHART */}
                    <Grid.Col span={{ base: 12, md: 6 }}>
                        <Text fw={600} mb="sm" ta="center">
                            VKT per Year
                        </Text>

                        <ResponsiveContainer width="100%" height={300}>
                            {/* <BarChart data={chartData}>
                                <CartesianGrid strokeDasharray="3 3" />

                                <XAxis
                                    dataKey="name"
                                    angle={-20}
                                    textAnchor="end"
                                    interval={0}
                                    height={60}
                                />

                                <YAxis domain={[0, (dataMax) => dataMax * 1.2]}
                                    allowDecimals={false} />

                                <Tooltip />
                                <Bar dataKey="vkt" radius={[8, 8, 0, 0]}>
                                    {chartData.map((entry, index) => (
                                        <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                                    ))}
                                    <Tooltip
                                        formatter={(value, key, props) => [
                                            value,
                                            key === "vkt" ? "VKT" : "CO₂",
                                        ]}
                                        labelFormatter={(label, payload) => {
                                            if (payload && payload.length) {
                                                const data = payload[0].payload;
                                                return `${data.fullName} (${data.fuel})`;
                                            }
                                            return label;
                                        }}
                                    />
                                </Bar>
                            </BarChart> */}
                            <BarChart data={chartData}>
                                <CartesianGrid strokeDasharray="3 3" />

                                <XAxis
                                    dataKey="name"
                                    angle={-20}
                                    textAnchor="end"
                                    interval={0}
                                    height={60}
                                />

                                <YAxis
                                    domain={[0, (dataMax) => dataMax * 1.2]}
                                    allowDecimals={false}
                                />

                                <Tooltip
                                    formatter={(value) => [value.toLocaleString(), "VKT"]}
                                    labelFormatter={(label, payload) => {
                                        if (payload && payload.length) {
                                            const data = payload[0].payload;
                                            return `${data.fullName} (${data.fuel})`;
                                        }
                                        return label;
                                    }}
                                />

                                <Bar dataKey="vkt" radius={[8, 8, 0, 0]}>
                                    {chartData.map((entry, index) => (
                                        <Cell key={index} fill={COLORS[index % COLORS.length]} />
                                    ))}
                                </Bar>
                            </BarChart>
                        </ResponsiveContainer>
                    </Grid.Col>

                    {/* 🔴 CO2 CHART */}
                    <Grid.Col span={{ base: 12, md: 6 }}>
                        <Text fw={600} mb="sm" ta="center">
                            Annual CO₂ Emissions
                        </Text>

                        <ResponsiveContainer width="100%" height={300}>
                            <BarChart data={chartData}>
                                <CartesianGrid strokeDasharray="3 3" />

                                <XAxis
                                    dataKey="name"
                                    angle={-20}
                                    textAnchor="end"
                                    interval={0}
                                    height={60}
                                />

                                <YAxis
                                    domain={[0, (dataMax) => dataMax * 1.2]}
                                    tickFormatter={(val) => val.toFixed(3)}
                                />

                                <Tooltip
                                    formatter={(value) => [value.toFixed(3), "CO₂ (mil tons)"]}
                                    labelFormatter={(label, payload) => {
                                        if (payload && payload.length) {
                                            const data = payload[0].payload;
                                            return `${data.fullName} (${data.fuel})`;
                                        }
                                        return label;
                                    }}
                                />


                                <Bar dataKey="co2" radius={[8, 8, 0, 0]}>
                                    {chartData.map((entry, index) => (
                                        <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                                    ))}
                                    {/* <Tooltip
                                        formatter={(value, key, props) => [
                                            value,
                                            key === "vkt" ? "VKT" : "CO₂",
                                        ]}
                                        labelFormatter={(label, payload) => {
                                            if (payload && payload.length) {
                                                const data = payload[0].payload;
                                                return `${data.fullName} (${data.fuel})`;
                                            }
                                            return label;
                                        }}
                                    /> */}
                                </Bar>
                            </BarChart>
                            {/* <BarChart data={chartData}>
                                <CartesianGrid strokeDasharray="3 3" />

                                <XAxis
                                    dataKey="name"
                                    angle={-20}
                                    textAnchor="end"
                                    interval={0}
                                    height={60}
                                />

                                <YAxis
                                    domain={[0, (dataMax) => dataMax * 1.2]}
                                    tickFormatter={(val) => val.toFixed(2)}
                                />

                                <Tooltip
                                    formatter={(value) => [value.toFixed(2), "CO₂ (mil tons)"]}
                                    labelFormatter={(label, payload) => {
                                        if (payload && payload.length) {
                                            const data = payload[0].payload;
                                            return `${data.fullName} (${data.fuel})`;
                                        }
                                        return label;
                                    }}
                                />

                                <Bar dataKey="co2" radius={[8, 8, 0, 0]}>
                                    {chartData.map((entry, index) => (
                                        <Cell key={index} fill={COLORS[index % COLORS.length]} />
                                    ))}
                                </Bar>
                            </BarChart> */}
                        </ResponsiveContainer>
                    </Grid.Col>
                </Grid>
            </Card>
        </Container>
    );
};

export default Home;